import script from "./UploadIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadIcon.vue?vue&type=script&setup=true&lang=js"

import "./UploadIcon.vue?vue&type=style&index=0&id=7b43be2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b43be2c"]])

export default __exports__